<template>
  <header style="margin-top: 20px;">
    <van-form @submit="onSubmit">
      <van-field
          v-model="telPhoneNumber"
          type="number"
          name="telPhoneNumber"
          label="电话号码"
          placeholder="请输入电话号码"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          拨打电话
        </van-button>
      </div>
    </van-form>
  </header>
</template>

<script>
import { api } from '@/api/index'
import { Button } from 'vant'
import { Form } from 'vant'
import { Field } from 'vant'
export default {
  name: 'InternetTelephone',
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  data() {
    return {
      telPhoneNumber: ''
    }
  },
  created() {
    this.getSDK()
  },
  methods: {
    getSDK() {
      api.getCloudCallSDKURL().then(res => {
        if (res.code === 10000) {
          // https://tccc.qcloud.com/sdk/tcccSdk.js?sdkAppId=1400794341&token=d3d3b961b6034349ada692a92a10cd1c&userid=liangbinbin%40xiaohebook.com
          this.injectTcccWebSDK(res.data)
        }
      })
    },
    injectTcccWebSDK(res) {
      if (window.tccc) {
        console.warn('已经初始化SDK了，请确认是否重复执行初始化')
        return
      }
      const scriptDom = document.createElement("script")
      scriptDom.setAttribute("crossorigin", "anonymous")
      scriptDom.dataset.token = res.token
      scriptDom.dataset.sdkAppId = res.sdkAppId
      scriptDom.dataset.userid = res.userId
      scriptDom.src = res.sdkUrl
      document.body.appendChild(scriptDom)
      scriptDom.addEventListener('load', () => {
        // 加载JS SDK文件成功，此时可使用全局变量"tccc"
        window.tccc.on(window.tccc.events.ready, () => {
          /**
           * Tccc SDK初始化成功，此时可调用外呼等功能。
           * 注意⚠️：请确保只初始化一次SDK
           * */
          console.log('初始化成功')
          window.tccc.UI.hidefloatButton()
        });
        window.tccc.on(window.tccc.events.tokenExpired, ({message}) => {
          console.log('初始化失败', message)
        })
      })
    },
    onSubmit(values) {
      window.tccc.Call.startOutboundCall({
        phoneNumber: values.telPhoneNumber
      }).then((res) => {
        this.sessionId = res.data.sessionId
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>